<template>
  <div class="container">
     <!-- <BaseButton title="Import test" @click.native="importGlobalSchema" theme="primary"/>
     <BaseButton title="Export test" @click.native="exportGlobalSchema" theme="primary"/>
     <BaseButton @click.native="showTutorialModal" title="SHOW TUTORIAL"></BaseButton> -->
    <Section v-for="(section, index) in baseSections" :key="index">
      <SectionInfo
        slot="info"
        :title="section.info.title"
        :text="section.info.text"
      ></SectionInfo>
      <SectionCategories
        slot="categories"
        :listLayout="section.listLayout"
        :categories="section.categories"
      ></SectionCategories>
    </Section>
   
    <Section>
      <SectionInfo
        slot="info"
        :title="customObjSection.info.title"
        :text="customObjSection.info.text"
      ></SectionInfo>
      <SectionCustomObjectsGroups
        slot="categories"
        :listLayout="customObjSection.listLayout"
        :allowDelete="true"
        :categories="customObjectsGroupsMapped"
      >
      <NewFieldButton slot="button" title="Add new custom object group" @click.native="onAddNewObjectGroup"/>
      </SectionCustomObjectsGroups>
    </Section>

    <Section>
      <SectionInfo
        slot="info"
        :title="settingsSection.info.title"
        :text="settingsSection.info.text"
      ></SectionInfo>
      <SectionCategories
        slot="categories"
        :listLayout="settingsSection.listLayout"
        :categories="settingsSection.categories"
      ></SectionCategories>
    </Section>

    <BaseHelpButton
      text="Learn more by reading our"
      icon="help"
      linkUrl="https://www.airfields.io"
      linkLabel="documentation."/>
  </div>
</template>

<script>
import Store from '@/stores'
import Section from '@/components/Section'
import SectionInfo from '@/components/SectionInfo'
import SectionCategories from '@/components/SectionCategories'
import SectionCustomObjectsGroups from '@/components/SectionCustomObjectsGroups'
import NewFieldButton from '@/components/NewFieldButton'
import { mapGetters } from 'vuex'
import { MDSModalIframeModel } from '@/models/modal-datasets.model'
import { baseSections, customObjSection, settingsSection } from '@/data/homepage'
import { logger } from '@/helpers'

export default {
  components: {
    Section,
    SectionInfo,
    SectionCategories,
    SectionCustomObjectsGroups,
    NewFieldButton
  },

  data () {
    return {
      baseSections,
      customObjSection,
      settingsSection
    }
  },

  computed: {
    ...mapGetters('shop', ['chargeDaysLeft', 'isPlanDev']),
    ...mapGetters('shopCustomobjectsgroupsList', ['customObjectsGroupsMapped'])
  },

  methods: {
    onAddNewObjectGroup () {
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewCustomObjectGroup' })
    },

    async exportGlobalSchema () {
      try {
        let result = await this.$store.dispatch('shopifyApi/SCHEMA_EXPORT')
      } catch (error) {
        console.error(error)
      }
    },

    async importGlobalSchema () {
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalImportWarning' })
    },

    showTutorialModal () {
      const canOpen = !(this.$store.getters['modals/modals'].find(item => item.name === 'ModalIframe'))
      if (!canOpen) return
        
      const props = new MDSModalIframeModel({
        src: 'https://www.airfields.io/tutorial'
      })
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalIframe', props })
    },
  },

  async beforeRouteEnter(to, from, next){
    try {
      try {
          await Store.dispatch(`shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS`)
          next()
      } catch (error) {
          console.error(`Couldn't resolve ${to.name} beforeRouteEnter requests`, { error })
          next({
              name: 'app.error',
              query: { type: 'API' }
          })
      }

      next()
    } catch(error) {
      console.error(`Couldn't resolve index.vue/home beforeRouteEnter requests`, { error })
      next({
        name: 'app.error',
        query: {
          type: 'API'
        }
      })
    }
  },

  created () {
    logger('this.baseSections:', this.baseSections)

    if (this.isPlanDev) {
      this.$store.commit('banners/SHOW_BANNER', {
        title: `Play around as much as you like while being on any development store.`,
        message: "Explore every feature for free while being on a development store. Your 7-day trial will start once you install Airfields on a production store.",
        // buttonLabel: "Subscribe in Advance",
        status: "info"
      })
    } else if (this.chargeDaysLeft > 0) {
      this.$store.commit('banners/SHOW_BANNER', {
        title: `You have ${this.chargeDaysLeft} days left until your trial expires`,
        message: "Thanks for giving us a try. We hope that Airfields has everything you need. If you have any outstanding questions contact us at support@airfields.io.",
        // buttonLabel: "Subscribe in Advance",
        status: "info"
      })
    }
  },

  mounted() {
      let modalToForce = this.$store.getters['modals/forceModal']
      if (modalToForce && modalToForce === 'ModalTutorial') {
        this.showTutorialModal()
        this.$store.commit('modals/SET_MODAL_TO_FORCE', { modal: null })
      }
      window.addEventListener('schema_import', this.importGlobalSchema, false)
      window.addEventListener('schema_export', this.exportGlobalSchema, false)
      window.addEventListener('show_tutorial', this.showTutorialModal, false)
  },

  beforeDestroy() {
      window.removeEventListener('schema_import', this.importGlobalSchema)
      window.removeEventListener('schema_export', this.exportGlobalSchema)
      window.removeEventListener('show_tutorial', this.showTutorialModal)
      this.$store.commit('banners/CLOSE_BANNER')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue